/**
 * Created by jonas on 2021-02-02.
 */

import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {IKarenGameData, IKarenInitData, IBetLineWinData} from "./data/IKarenData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {StateMatrix} from "../../core/utils/StateMatrix";
import {KarenParsedInitData} from "./data/KarenParsedInitData";
import {KarenParsedGameData} from "./data/KarenParsedGameData";
import {KarenDataParser} from "./data/KarenDataParser";
import {KarenSymbolState} from "../symbol/KarenSymbolConfig";
import {Karen} from "../Karen";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class KarenModel extends GameModel<IKarenInitData, IKarenGameData> {

    public parsedInitData:KarenParsedInitData;
    public parsedGameData:KarenParsedGameData;
    public reels:string[][];
    public initReels:string[][] = [];
    public isRestore:boolean = false;
    public isRestoreFeatureBet : boolean;
    public buyFeatureName : string;
    private _parser:KarenDataParser;

    // constructor(api:ApiPlugin, triggerEvents:boolean = true) {
    //     super(api, triggerEvents);

    // }
    constructor(api: ApiPlugin, triggerEvents: boolean = true) {
        super(api, triggerEvents);
        api.events.once("featureBet", (data : boolean)=>{
            this.isRestoreFeatureBet = data;
        });
        api.events.once("featureName", (data : string)=>{
            this.buyFeatureName = data;
        });
        Karen.apiPlugin.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {
            for (let index = 0; index < Karen.model.initData.featureBuyTimesBetValue.length; index++) {
                if (Karen.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });
        Karen.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            for (let index = 0; index < Karen.model.initData.featureBuyTimesBetValue.length; index++) {
                if (Karen.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });
        this._parser = new KarenDataParser();
    }


    protected onInit(data:IKarenInitData):void {
        this.parsedInitData = new KarenParsedInitData(data, this._parser);
        this.reels = this.parsedInitData.reels;
        this.isRestore = data.isRestoreState;
        this.initReels = Object.assign([],this.parsedInitData.reels);
        super.onInit(data);
    }

    protected onGame(data:IKarenGameData):void {
        this.parsedGameData = new KarenParsedGameData(data, this._parser);
        this.reels = this.parsedGameData.reels;
        this.isRestore = false;
        super.onGame(data);
    }
}